'use client';

import React from 'react';
import useProfileStrategies from 'src/hooks/strategy/useProfileStrategies';
import { StrategyFeatureMarker } from 'src/components/Strategy/shared';

type StrategyProfileMarkerProps = {
  listMember: any;
  position: { lat: number; lng: number };
  isHovered?: boolean;
  onMarkerClick?: (memberId: string) => void;
  onMouseOver?: (memberId: string) => void;
  onMouseOut?: () => void;
  onAddToList?: () => void;
};

const StrategyProfileMarker = (props: StrategyProfileMarkerProps) => {
  const { selectedProviders, setSelectedProviders, setSelectedProvider } =
    useProfileStrategies();

  return (
    <StrategyFeatureMarker
      {...props}
      setSelectedProvider={setSelectedProvider}
      selectedProviders={selectedProviders}
      setSelectedProviders={setSelectedProviders}
    />
  );
};

export default StrategyProfileMarker;
